import SubmissionCard from './Card'
export default SubmissionCard
